import { render } from "./FacturasAnuladas.vue?vue&type=template&id=1d391efa"
import script from "./FacturasAnuladas.vue?vue&type=script&lang=js"
export * from "./FacturasAnuladas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__